module.exports = __webpack_public_path__ + "stylesheets/different-devices_647f9c3df3afa99466839f52f4638200.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/different-devices.less
// module id = Ir05
// module chunks = 118